import { v4 as uuidv4 } from 'uuid';
import { useCallback } from 'react';
import { FieldArray, FieldArrayRenderProps } from 'react-final-form-arrays';

import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { Button } from 'UIPackage/MainModule/components/Button';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { IKnmActFamiliarizationNotificationsForm } from 'KnmErknmPackage/MainModule/interfaces/IKnmActFamiliarizationNotificationsForm';
import { IDecisionFormRef } from 'DecisionPackage/MainModule/interfaces/IDecisionFormRef';
import { Hint } from 'CorePackage/MainModule/components/Hint';

import { ResultDecisionsItemContentIntroductionsItem } from './ResultDecisionsItemContentIntroductionsItem';
import styles from './ResultDecisionsItemContentIntroductions.module.scss';

interface IResultDecisionsItemContentIntroductionsProps {
  id: string;
  name: string;
  formRef: IKnmFormRef | IDecisionFormRef | undefined;
}

export const ResultDecisionsItemContentIntroductions = ({
  id,
  name,
  formRef,
}: IResultDecisionsItemContentIntroductionsProps) => {
  const remove = formRef?.current.mutators.remove;
  const push = formRef?.current.mutators.push;

  const addNotify = useCallback(() => {
    if (push) {
      const addingEvent: IKnmActFamiliarizationNotificationsForm = {
        listId: uuidv4(),
        isNew: true,
        knmNoticeType: undefined,
        note: undefined,
        noticeDate: undefined,
      };

      push(`${name}.familiarizationNotifications`, addingEvent);
    }
  }, [formRef, push]);

  const makeRemoveNotifyHandler = (index: number, isNew: boolean) => () =>
    isNew && remove && remove(`${name}.familiarizationNotifications`, index);

  return (
    <FieldBlock
      className={styles.GroupMarginBottom}
      margin="top"
      label={'Уведомление контролируемого лица о предписании'}
      button={
        <Button
          className="shared-btn-add"
          text="Добавить"
          variant="link"
          color="primary"
          type="button"
          onClick={addNotify}
        />
      }
    >
      <>
        <Hint
          text="Если уведомление контролируемого лица производится через портал Госуслуги, соответствующая информация размещается и
          обновляется автоматически. Вручную указывать такие сведения не требуется."
        />
        <FieldArray name={`${name}.familiarizationNotifications`}>
          {({ fields }: FieldArrayRenderProps<IKnmActFamiliarizationNotificationsForm, HTMLElement>) => {
            if (!fields.length) {
              return null;
            }

            return fields.map((fieldName, sIndex) => {
              const fieldValue: IKnmActFamiliarizationNotificationsForm = fields.value?.[sIndex];
              const itemId = `${id}.familiarizationNotifications[${fieldValue.listId}]`;

              return (
                <ResultDecisionsItemContentIntroductionsItem
                  fieldValue={fieldValue}
                  id={itemId}
                  key={itemId}
                  isDisabledField={!fieldValue.isNew}
                  name={fieldName}
                  remove={makeRemoveNotifyHandler(sIndex, fieldValue.isNew)}
                />
              );
            });
          }}
        </FieldArray>
      </>
    </FieldBlock>
  );
};
